const values = (folder, ...groups) => {
  const result = {}
  groups.forEach(group => {
    if (typeof group == 'string') {
      group.split(' ').forEach(e => (result[e] = `${folder}/${e}`))
    } else {
      Object.entries(group).forEach(([key, value]) => (result[key] = `${folder}/${value}`))
    }
  })
  return result
}

// Note - when user is logged out they're limited to values in P_REACT_PUBLIC_LABELS
const groups = {
  filters: {
    ...values('GeneralLabels', 'hot online', { matches: 'myMatches' }),
    ...values('search/PresetMenu', 'new featured nearMe'),
    visitors: 'search/visitors',
  },
  sections: {
    ...values('GeneralLabels/Menus', 'home browse privacy terms about profile notifications impressumLink usc'),
    ...values('search', 'featuredMembers newMatches newMembers'),
    myProfile: 'page/MainMenu/myProfile',
    flirt: 'games/flirt/name',
    flirtMy: 'games/flirt/MyFlirts/name',
    flirtWithMe: 'games/flirt/FlirtedWithMe/name',
    flirtMutual: 'games/flirt/Mutual/name',
    mailbox: 'GeneralLabels/Menus/mail',
    help: 'GeneralLabels/Menus/faqs',
    topFlirts: 'games/flirt/Flirt/topFlirtsOfTheWeek',
    matches: 'GeneralLabels/myMatches',
    cookies: 'GeneralLabels/Menus/cookiesText',
    findADate: 'react/sections/findDate',
    settings: 'profile/UpdateProfileDetails/settings',
    photofilter: 'profile/AdultRatingFilter/Photofilter',
    unsubscribe: 'support/Unsubscribe/unsubscribe',
    onlineMembers: 'chat/membersOnlineNow',
  },
  generalLabels: {
    ...values(
      'GeneralLabels',
      'age cancel aboutMyMatch aboutMe iAm seeking seekingSimple to city country region screenname sex starSign warningActionsLogged wink hot save viewMore oops skip',
      { membership: 'membershipGen', email: 'emailAddress' }
    ),
    ...values('GeneralLabels/Pager', 'prev next'),
    ...values('GeneralLabels/Menus', 'language'),
    ...values('controller', 'ALL_COUNTRIES ALL_REGIONS ALL_CITIES'),
    ...values('profile', 'orientation interests languages'),
    ...values('profile/UpdateProfileDetails', 'receiveEmailsIn newPassword confirmNewPassword emailSettings mobile'),
    ...values('search/Search', 'onlyWith withGallery onlineOnly locationDist'),
    ...values('games/flirt/Flirt', 'uploadYourPhotoNow uploadPhotoToBoostChances'),
    poweredBy: 'page/Footer/poweredBy',
    password: 'authorization/Login/password',
    month: 'payment/UpgradeAccount/month',
    or: 'authorization/PasswordRecovery/or',
    default: 'profile/gallery/MediaItem/default',
    enterValidEmail: 'registration/enterValidEmail',
    yesterday: 'chat/yesterday',
    ...values('chat/ChatHistory', 'secondsAgo minutesAgo hoursAgo daysAgo'),
    dragAndDrop: 'profile/UploadPhoto/dragAndDrop',
    filterHint: 'profile/AdultRatingFilter/filterHint',
    ...values('registration/CompleteRegistration', 'tellOthers warningMandatoryFields complete'),
    greatOpportunity: 'registration/UniversalRegistrationConfirm/asNewMemberYouHaveGreateOpportunity',
    virtualHottieProfileDisclaimer: 'GeneralLabels/virtualHottieProfileDisclaimer',
    nonVirtualHottieProfileDisclaimer: 'GeneralLabels/nonVirtualHottieProfileDisclaimer',
    virtualHottieBecomeVIP: 'GeneralLabels/virtualHottieBecomeVIP',
  },
  removeAccount: {
    ...values('profile/RemoveAccount', 'deleteProfileButton reason warningPermanent'),
    ...values('profile/RemoveAccountResult', 'accountRemoved thankYouForChoosing'),
  },
  membership: {
    ...values('GeneralLabels/MembershipStatus', { trial: 'FREE', gold: 'GOLD', vip: 'VIP' }),
    ...values('react/upgrade', 'filtersForGold upgradeToUnlock1 upgradeToUnlock2'),
    upgradeToFlirt: 'games/flirt/Flirt/upgradeNowToFlirtEveryDay',
    upgradeForXxx: 'GeneralLabels/Photos/upgradeToSeeXxxPhotos',
    disallowedText: 'search/Search/disallowedText',
  },
  payment: {
    ...values(
      'payment',
      'callCenter suspendBilling action cancelBillingQuestion description nextBillingDate noAgreements stayAsMember stillLeaving pleaseTell selectPlan reason',
      {
        pleaseNote: 'CancelAgreement/pleaseNote',
        alwaysSecure: 'alwaysSecureAndCompliant',
        continue: 'UpgradeAccount/continue',
      }
    ),
    ...values('payment/CancelAgreement/suspend_by_fax', 'generatePdfFile suspendReasonOther'),
    ...values(
      'payment/UpgradeAccountResult',
      'upgradeSuccess thankYouForUpgrading paymentIsProcessed ifDontReceiveEmail contactSupport continueBrowsing thanksForChoosing hopeYouEnjoy'
    ),
    // VIP enabled
    ...values(
      'payment',
      'membershipAdvantages',
      'viewVisitors readMessages viewProfiles viewHotlist viewGalleries viewZoom everyoneReply getLaidGarantee clickHereForMoreInfo callCenter'
    ),
  },
  messages: {
    detailsUpdated: 'profile/UpdateProfileDetails/detailsUpdated',
    ...values(
      'react/messages',
      'userWinked userVisited userLiked userFlirted chatWithSomeone uploadPhoto fillYourInfo unlockSearch getVipStatus noResults1 noResults2 tryFlirtOption'
    ),
    ...values('GeneralLabels', { serverError: 'serverErrorMsg', weUseCookies: 'acceptCookiesText' }),
    ...values('games/flirt/Flirt', 'wantToBeInTheRunning beFair'),
    wantToFlirt: 'games/flirt/Banner/doYouWannaFlirtWith',
    noMoreMembers: 'games/flirt/Flirt/oopAnyMoreMembers',
    imageFormatError: 'profile/gallery/MediaItem/imageErrorMessage',
    tooSmallImage: 'popup/tooSmallImage',
  },
  flirt: {
    allMembersFlirt: 'games/flirt/MyFlirts/hereAreAllTheMembersYouSaid',
    flirtExpiration: 'games/flirt/MyFlirts/messagesExpirationNotification',
    luckIsIn: 'games/flirt/FlirtedWithMe/yourLuckIsIn',
    talkToThem: 'games/flirt/FlirtedWithMe/talkToThem',
    upgradeNowToEnjoy: 'games/flirt/Mutual/upgradeNowToEnjoy',
    enjoy: 'games/flirt/enjoy',
    noMembers: 'search/noMembers',
  },
  actions: {
    chat: 'GeneralLabels/Actions/chat',
    chatNow: 'chat/chatNowExcl',
    ...values('GeneralLabels', 'wink hot update'),
    ...values('react/actions', 'winkBack likeBack goForIt'),
    ...values('profile/gallery/MediaItem', 'chooseFile upload'),
    ...values('profile/gallery/MediaGallery', 'viewAll setDefault'),
    ...values('informer/InformerMessage', 'flirt', { uploadPhoto: 'uploadYourPhoto' }),
    ...values('GeneralLabels/Menus', 'upgrade logout back'),
    ...values('mailbox', 'send sendMessage reply'),
    accept: 'page/Cookie/Accept',
    crop: 'profile/UploadPhoto/crop',
    getNoticed: 'registration/IntroPopup/getNoticed',
    search: 'search/search',
    editSearch: 'search/Search/editSearch',
    completeYourProfile: 'registration/Registration/completeYourProfile',
    favorite: 'search/friends',
  },
  confirmation: {
    ...values('authorization/PasswordRecovery', 'resend', {
      checkJunk: 'popup/importantList0',
      toStartReceivingMessages: 'popup/toStartReceivingMessages',
      notReceived: 'haventReceivedActivationLink',
      wrongEmail: 'enteredWrongEmail',
    }),
    confirmEmail: 'GeneralLabels/emailAddressConfirm',
  },
  support: {
    support: 'support/Support',
    submit: 'support/submit',
    ...values('support/Unsubscribe', 'going unsubscribe miss manage buttonMng'),
    ...values('support/ContactUs', 'supportName supportMail supportLanguage supportCat describeRequest'),
  },
  logout: values(
    'authorization/Logout',
    'youSuccessfullyLoggedOut done didYouLogOutByMistake goBack orWaitAndLetUsTakeYouReact'
  ),
  ccp: {
    ...values(
      'ccp',
      'conversations justNow smileys stickers textingNow typeAMessage upgrade userWarning warningTitle messageLimit'
    ),
    blocked: 'search/PresetMenu/blocked',
    close: 'GeneralLabels/close',
  },
}

const labels = {}
Object.keys(groups).forEach(group =>
  Object.entries(groups[group]).forEach(([key, oldKey]) => {
    labels[`${group}/${key}`] = oldKey
  })
)

export default labels
